import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { PagePasswordCheckEmail, PageChangePassword, PageChangePasswordSuccess } from 'views/Home/ChangePassword/'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Switch>
    <Route path={`${match.path}`} component={PagePasswordCheckEmail} exact />
    <Route path={`${match.path}/success`} component={PageChangePasswordSuccess} />
    <Route path={`${match.path}/:token`} component={PageChangePassword} />
  </Switch>
)
 